import { Route, Routes } from 'react-router-dom';
import styles from './App.module.css';
import { Snackbar } from '../../../components/Snackbar/SnackbarContext';
import { TopAppBar } from '../../app/app-nav/TopAppBar';
import EmailAgentHome from '../EmailAgentHome';

export function App() {
  return (
    <div className={styles.app}>
      <Snackbar>
        <TopAppBar />
        <div className={styles.appContainer}>
          <Routes>
            <Route path="/" element={<EmailAgentHome />} />
          </Routes>
        </div>
      </Snackbar>
    </div>
  );
}